import { render, staticRenderFns } from "./CouponSquareSettings.vue?vue&type=template&id=462895d8&scoped=true"
import script from "./CouponSquareSettings.vue?vue&type=script&lang=js"
export * from "./CouponSquareSettings.vue?vue&type=script&lang=js"
import style0 from "./CouponSquareSettings.vue?vue&type=style&index=0&id=462895d8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462895d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('462895d8')) {
      api.createRecord('462895d8', component.options)
    } else {
      api.reload('462895d8', component.options)
    }
    module.hot.accept("./CouponSquareSettings.vue?vue&type=template&id=462895d8&scoped=true", function () {
      api.rerender('462895d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/operationsManagement/Component/CouponSquareSettings.vue"
export default component.exports